import React from 'react';
import ParliamentRedirect from '../ParliamentRedirect/ParliamentRedirect';

const AminVoting: React.FC = () => {
    return <ParliamentRedirect parliamentName="Anime Voting" />;
};

export default AminVoting;
